import {put, takeLatest, call} from 'redux-saga/effects';
import * as extraService from "../../../../services/extraService.js";
import {
    DELETE_EXTRAS,
    DELETE_EXTRAS_SUCCESS,
    DELETE_EXTRAS_ERROR
}
    from "../../../actions/menu/extras";

function* deleteExtrasSaga(action) {
    try {
        yield call(extraService.DeleteExtras, action.payload)
        
        yield put({
            type: DELETE_EXTRAS_SUCCESS,
            payload: action.payload._ids
        });

    } catch (error) {
        yield put({
            type: DELETE_EXTRAS_ERROR,error: error.data
        });
    }
}


export function* deleteExtrasSagaWatcher() {
    yield takeLatest(DELETE_EXTRAS, deleteExtrasSaga);
}